'use strict'

var fromCharCode = String.fromCharCode

module.exports = fromCharCode



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/constant/from-char-code.js
// module id = 326
// module chunks = 0